import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import StateSelectionStep from './StateSelectionStep';
import HomePage from './HomePage';

const StateBasedHomePage = ({ workflow = 'retail' }) => {
  const [currentStep, setCurrentStep] = useState('state-selection');
  const [selectedState, setSelectedState] = useState(null);
  const [stateInfo, setStateInfo] = useState(null);

  const handleStateSelected = (stateCode, stateData) => {
    setSelectedState(stateCode);
    setStateInfo(stateData);
    setCurrentStep('document-upload');
  };

  const handleBackToStateSelection = () => {
    setCurrentStep('state-selection');
    setSelectedState(null);
    setStateInfo(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Progress Steps */}
      <div className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className={`flex items-center ${
              currentStep === 'state-selection' 
                ? 'text-blue-600 font-semibold' 
                : 'text-gray-400'
            }`}>
              <span className="mr-2">1</span>
              <span>Select State</span>
            </div>
            <div className="flex-1 h-0.5 bg-gray-300 mx-4" />
            <div className={`flex items-center ${
              currentStep === 'document-upload' 
                ? 'text-blue-600 font-semibold' 
                : 'text-gray-400'
            }`}>
              <span className="mr-2">2</span>
              <span>Upload Documents</span>
            </div>
            <div className="flex-1 h-0.5 bg-gray-300 mx-4" />
            <div className="flex items-center text-gray-400">
              <span className="mr-2">3</span>
              <span>Extract & Review</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="py-8">
        {currentStep === 'state-selection' && (
          <StateSelectionStep 
            onStateSelected={handleStateSelected}
            workflow={workflow}
          />
        )}

        {currentStep === 'document-upload' && (
          <div>
            {/* Back Button & State Badge */}
            <div className="max-w-4xl mx-auto px-6 mb-6">
              <button
                onClick={handleBackToStateSelection}
                className="flex items-center text-blue-600 hover:text-blue-700 mb-4"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to State Selection
              </button>
              
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-lg font-semibold">
                <span className="mr-2">Selected State:</span>
                <span>{stateInfo?.name} ({selectedState})</span>
              </div>
            </div>

            {/* Original HomePage with state context */}
            <HomePage 
              selectedState={selectedState}
              stateInfo={stateInfo}
              workflow={workflow}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StateBasedHomePage;
